import { all, takeLatest } from 'redux-saga/effects'
// Types
import { AuthTypes } from 'store/redux/auth'
import { PhaseTypes } from 'store/redux/phase'
import { PhaseInfoTypes } from 'store/redux/phaseInfo'
import { SystemTypes } from 'store/redux/system'
import { MocksTypes } from 'store/redux/mocks'
import { McTypes } from 'store/redux/mc'
import { SuperAdminTypes } from 'store/redux/superadmin'
// Sagas
import { signin, handleAuthenticated, handleUserData, setNickname, handlePlayerUpdated, handleUnauthorized, signout, tryReconnect } from './auth'
import { endPhase } from './phase'
import { onPhaseUpdated } from './phaseInfo'
import { startup } from './system'
import {
    requestNewGameTemplate,
    handleNewGameTemplateData,
    newGameSaveStep1,
    newGameSaveStep2,
    requestNewGame,
    handleNewGameData,
    requestBotsDefaultValues,
    handleBotsDefaultValues,
    updateGameBots,
    handleGameBotsUpdated,
    requestGameData,
    handleGameData,
    handleGameLogData,
    requestGameList,
    handleGameList,
    requestGameCSV,
    handleGameCSV,
    handleServerError as mcHandleError
} from './mc'
import {
    requestMcList,
    handleMcList,
    requestNewMc,
    handleNewMc,
    requestUpdateMc,
    handleUpdateMc,
    requestUpdateMcPassword,
    handleUpdateMcPassword,
    requestDeleteMc,
    handleDeleteMc,
    requestConfigFileData,
    handleConfigFileData,
    requestUpdateConfigFile,
    handleUpdatedConfigFile,
    handleServerError as superAdminHandleError
} from './superadmin'

import { cleanData, simulatePreSeason, simulatePreRace, simulateRace, simulatePostRace, simulatePostSeason } from './mocks'

export default function* rootSaga() {
    const sagaIndex = [
        // Auth
        takeLatest(AuthTypes.SIGNIN, signin),
        takeLatest(AuthTypes.HANDLE_AUTHENTICATED, handleAuthenticated),
        takeLatest(AuthTypes.HANDLE_USER_DATA, handleUserData),
        takeLatest(AuthTypes.SET_NICKNAME, setNickname),
        takeLatest(AuthTypes.HANDLE_PLAYER_UPDATED, handlePlayerUpdated),
        takeLatest(AuthTypes.HANDLE_UNAUTHORIZED, handleUnauthorized),
        takeLatest(AuthTypes.SIGNOUT, signout),
        takeLatest(AuthTypes.TRY_RECONNECT, tryReconnect),
        // System
        takeLatest(SystemTypes.STARTUP, startup),
        // Phase
        takeLatest(PhaseTypes.END_PHASE, endPhase),
        // PhaseInfo
        takeLatest(PhaseInfoTypes.ON_PHASE_UPDATED, onPhaseUpdated),
        // MOCKS
        takeLatest(MocksTypes.CLEAN_DATA, cleanData),
        takeLatest(MocksTypes.SIMULATE_PRE_SEASON, simulatePreSeason),
        takeLatest(MocksTypes.SIMULATE_PRE_RACE, simulatePreRace),
        takeLatest(MocksTypes.SIMULATE_RACE, simulateRace),
        takeLatest(MocksTypes.SIMULATE_POST_RACE, simulatePostRace),
        takeLatest(MocksTypes.SIMULATE_POST_SEASON, simulatePostSeason),
        // Master of Ceremonies
        takeLatest(McTypes.REQUEST_NEW_GAME_TEMPLATE, requestNewGameTemplate),
        takeLatest(McTypes.HANDLE_NEW_GAME_TEMPLATE_DATA, handleNewGameTemplateData),
        takeLatest(McTypes.NEW_GAME_SAVE_STEP1, newGameSaveStep1),
        takeLatest(McTypes.NEW_GAME_SAVE_STEP2, newGameSaveStep2),
        takeLatest(McTypes.REQUEST_NEW_GAME, requestNewGame),
        takeLatest(McTypes.HANDLE_NEW_GAME_DATA, handleNewGameData),
        takeLatest(McTypes.REQUEST_BOTS_DEFAULT_VALUES, requestBotsDefaultValues),
        takeLatest(McTypes.HANDLE_BOTS_DEFAULT_VALUES, handleBotsDefaultValues),
        takeLatest(McTypes.UPDATE_GAME_BOTS, updateGameBots),
        takeLatest(McTypes.HANDLE_GAME_BOTS_UPDATED, handleGameBotsUpdated),
        takeLatest(McTypes.REQUEST_GAME_DATA, requestGameData),
        takeLatest(McTypes.HANDLE_GAME_DATA, handleGameData),
        takeLatest(McTypes.HANDLE_GAME_LOG_DATA, handleGameLogData),
        takeLatest(McTypes.REQUEST_GAME_LIST, requestGameList),
        takeLatest(McTypes.HANDLE_GAME_LIST, handleGameList),
        takeLatest(McTypes.REQUEST_GAME_C_S_V, requestGameCSV),
        takeLatest(McTypes.HANDLE_GAME_C_S_V, handleGameCSV),
        takeLatest(McTypes.HANDLE_SERVER_ERROR, mcHandleError),
        // Super Admin
        takeLatest(SuperAdminTypes.REQUEST_MC_LIST, requestMcList),
        takeLatest(SuperAdminTypes.HANDLE_MC_LIST, handleMcList),
        takeLatest(SuperAdminTypes.REQUEST_NEW_MC, requestNewMc),
        takeLatest(SuperAdminTypes.HANDLE_NEW_MC, handleNewMc),
        takeLatest(SuperAdminTypes.REQUEST_UPDATE_MC, requestUpdateMc),
        takeLatest(SuperAdminTypes.HANDLE_UPDATE_MC, handleUpdateMc),
        takeLatest(SuperAdminTypes.REQUEST_UPDATE_MC_PASSWORD, requestUpdateMcPassword),
        takeLatest(SuperAdminTypes.HANDLE_UPDATE_MC_PASSWORD, handleUpdateMcPassword),
        takeLatest(SuperAdminTypes.REQUEST_DELETE_MC, requestDeleteMc),
        takeLatest(SuperAdminTypes.HANDLE_DELETE_MC, handleDeleteMc),
        takeLatest(SuperAdminTypes.REQUEST_CONFIG_FILE_DATA, requestConfigFileData),
        takeLatest(SuperAdminTypes.HANDLE_CONFIG_FILE_DATA, handleConfigFileData),
        takeLatest(SuperAdminTypes.REQUEST_UPDATE_CONFIG_FILE, requestUpdateConfigFile),
        takeLatest(SuperAdminTypes.HANDLE_UPDATED_CONFIG_FILE, handleUpdatedConfigFile),
        takeLatest(SuperAdminTypes.HANDLE_SERVER_ERROR, superAdminHandleError)
    ]
    yield all(sagaIndex)
}



// WEBPACK FOOTER //
// src/store/sagas/index.js